import { PluginRemoveRelation } from '../../../types/plugins';
import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../constants/pluginBasePath';

export const runRemoveRelation = (
  constructPost: ConstructPost,
  data: PluginRemoveRelation,
): Promise<NonPaginatedResponse<any> | undefined> =>
  constructPost<NonPaginatedResponse<any>>(
    `${PLUGIN_BASE_PATH}/remove-relation`,
    { data },
    { preventDefaultErrorToast: true },
  );
